import { HexElementProperties } from '~/types/drill'
import { TOPIC_HEXAGON_PROPERTIES } from '~/shared/constants/drill.const'

export function getProperties(index: number): HexElementProperties {
  switch (index) {
    case 1:
    case 3:
    case 7:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
      }

    case 5:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#757bfb',
        i18nKey: 'playAlt',
        splat: 'right',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 9:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#757bfb',
        i18nKey: 'playAlt',
        splat: 'left',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 10:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.SOLUTION,
      }

    default:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.DEFAULT,
      }
  }
}
